import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';

function CompanyModalUpdate(props) {
  const { open, close, companyName, handleInputChange, email, showPassword, password, message, done } = props;

  const [state, setState] = React.useState({
    showPassword: showPassword || false,
  });

  if (!open) return null;

  return (
    <Dialog onClose={close} title="Cambiar correo y contraseña">
      <div className="modal-update-company">
        <p className="feedmodal-title">Cambiar correo y contraseña</p>
        <p className="update-modal-title">{companyName}</p>
        <div className="">
          <p className="update-modal-label">Correo electrónico:</p>
          <input
            className="update-modal-input"
            name="email"
            type="email"
            value={email}
            onChange={(e) => {
              handleInputChange(e);
            }}
          />
          <p className="update-modal-label">Contraseña:</p>
          <input
            className="update-modal-input"
            name="password"
            type={state.showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => {
              handleInputChange(e);
            }}
          />
          <div className="toggle-password-container-su">
            <input
              type="checkbox"
              className="toggle-password"
              onClick={() => {
                setState((prev) => ({
                  ...prev,
                  showPassword: !prev.showPassword,
                }));
              }}
              id="togglePassword"
            />
            <label className="toggle-password-label-su text-black" htmlFor="togglePassword">
              Mostrar contraseña
            </label>
          </div>
          {message ? (
            <p className="feedmodal-message mt-update-modal">Espera un momento mientras se procesa tu solicitud...</p>
          ) : null}
          <div className="update-modal-buttons">
            {!message ? (
              <button className="update-modal-button-update" onClick={done}>
                Cambiar
              </button>
            ) : null}
            {!message ? (
              <button className="update-modal-button-cancel" onClick={close}>
                Cancelar
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default CompanyModalUpdate;
